import React from "react";
import { Textarea } from "@emisgroup/ui-input";

interface CustomTextareaProps {
/**
 * Data test id for the current textarea
 */
  dataTestId?: string;
  /**
   * Name for the current textarea
   */
  name?: string;
  /**
   * Id for the current textarea
   */
  id?: string;
  /**
   * Event handler while onChanging the current textarea
   */
  onChange?: (e: React.SyntheticEvent<any, Event>) => void;
  /**
   * Current value that is available in the textarea
   */
  value?: string | number | readonly string[];
  /**
   * Responsible for the current textarea to be enabled or disabled
   */
  disabled?: boolean;
  /**
   * Classname for the current textarea
   */
  className?: string;
  /**
   * No of rows allowed in text area
   */
  rows?: number;
  /**
   * Current textarea to be valid or invalid
   */
  invalid?: boolean;
  /**
   * Current textarea is mandatory or not
   */
  required?: boolean;
}

/**
 * Responsible for rendering the input element
 * @returns textarea html component
 */
export const UITextarea: React.FC<CustomTextareaProps> = (props: CustomTextareaProps) => {

  const {
    name,
    id,
    dataTestId,
    onChange,
    value,
    disabled,
    className,
    rows,
    required,
    invalid
  } = props;

  return (
    <Textarea
      className={className}
      data-testid={dataTestId}
      id={id}
      name={name}
      value={value}
      disabled={disabled}
      onChange={onChange}
      rows={rows}
      required={required}
      invalid={invalid}
    />
  );
};
